export const FETCH_COMPANY = "FETCH_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
